import Card from "@mui/material/Card";
import classes from "./index.module.scss";

type Props = {
  title?: string;
  children: React.ReactElement;
  style?: React.CSSProperties;
};

const CardContainer = (props: Props) => {
  const { title, children, style } = props;

  return (
    <Card
      style={{
        width: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        ...style,
      }}
      className={classes.container}
    >
      {title && <p className={classes.cardTitle}>{title}</p>}
      {children}
    </Card>
  );
};

export default CardContainer;
